import { range } from 'lodash';
import moment from 'moment';
import { useContext, useEffect, useMemo, useState } from 'react';
import { UserContext } from '../../context/UserContext';
import { renderSpinner } from '../../utils/Utility';
import { PERMISSIONS } from '../../constants';
import { RetrospectiveGoalsDataGrid } from './RetrospectiveGoalsDataGrid';
import { getRetrospectiveGoalsByYearAndUsername } from '../../utils/API/retrospectiveGoals';
import { MonoSelectUser } from '../../components/Form/MonoSelectUser';
import { EmployeeListContext } from '../../context/EmployeeListContext';
import { Unauthorized } from '../../components/Unauthorized';

export const RetrospectiveGoalsPage = () => {
  const { hasClaim } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const { employeesQueryA: employees, employeesByIdQueryA: employeesById } = useContext(EmployeeListContext);
  const [retrospectiveGoals, setRetrospectiveGoals] = useState([]);

  const availableYears = range(2023, moment().year() + 1);
  const [year, setYear] = useState(moment().year());
  const [userId, setUserId] = useState();
  const username = useMemo(
    () => employeesById[userId]?.username,
    [userId, employeesById]
  );

  useEffect(() => {
    setIsLoading(true);
    const getData = async () => {
      setRetrospectiveGoals(
        await getRetrospectiveGoalsByYearAndUsername(year, username)
      );
    };
    getData().finally(() => setIsLoading(false));
  }, [year, username]);

  if (!hasClaim(PERMISSIONS.RETROSPECTIVE_GOALS_VIEW)) {
    return <Unauthorized />;
  }

  const showUserColumn = hasClaim(PERMISSIONS.RETROSPECTIVE_GOALS_USER_SELECTION);

  return (
    <>
      <div className="content__wrapper">
        <div className="headerPage content">
          <div className="title">Obiettivi</div>
          <div className="spacer" />
          <div className="d-flex gap-3 form-group">
            {hasClaim(PERMISSIONS.RETROSPECTIVE_GOALS_USER_SELECTION) && (
              <MonoSelectUser select={setUserId} users={employees} />
            )}
            <select
              className="yearContainer"
              defaultValue={year}
              onChange={({ target: { value } }) => setYear(+value)}
            >
              {availableYears.map((n) => (
                <option value={+n} key={+n}>
                  {n}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="content__fixed_height">
          <div className="tabsContainer" style={{ flex: '1 1 0px' }}>
            {isLoading ? (
              renderSpinner(true)
            ) : (
              <RetrospectiveGoalsDataGrid data={retrospectiveGoals} showUserColumn={showUserColumn} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
